/** §B7.3/§6: a badge is always text plus colour, never colour alone. The caller supplies already-translated text. */
export function Badge({
  children,
  tone = "neutral",
  dot = false,
}: {
  children: React.ReactNode;
  /** `neutral` is the grey "missing" tone of §6; `run` is the blue in-progress tone; `accent` is the
   * accent-soft/accent-hover pill the design uses for practice roles (Owner). */
  tone?: "neutral" | "pass" | "fail" | "warn" | "run" | "accent";
  /** §3: a status pill carries a 6 px dot in the pill colour; a label badge ("Read-only") does not. */
  dot?: boolean;
}): JSX.Element {
  const toneClass =
    tone === "neutral"
      ? "pill--MISSING"
      : tone === "pass"
        ? "pill--PASS"
        : tone === "fail"
          ? "pill--FAIL"
          : tone === "warn"
            ? "pill--WARN"
            : tone === "run"
              ? "pill--RUN"
              : "pill--ACCENT";
  return (
    <span className={`badge ${toneClass}`}>
      {dot ? <span className="pill__dot" aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
